import request from './http';

/**
 * 用户查询
 * @param {String} type 证书类别
 * @param {String} cardid 证据号
 * @param {String} name 姓名
 * @param {String} code 信用代码
 * @returns 
 */
export const certificateGR = function (type,code, name, cardid) {
  return request.get(`/zhcpw/certificateGR/userGetCert?certtypename=${type}&code=${code}&name=${name}&cardid=${cardid}`);
}
/**
 * 用户查询企业证书
 * @param {String} code 证书编号
 * @param {String} qiyename 企业名称
 * @param {String} socialcreditcode 信用代码
 * @returns 
 */
export const certificateQY = function (type,code, qiyename, socialcreditcode) {
  return request.get(`/zhcpw/certificateQY/userGetCert?certtypename=${type}&code=${code}&qiyename=${qiyename}&socialcreditcode=${socialcreditcode}`);
}
/**
 * 用户个人会员
 * @param {String} code 证书编号
 * @param {String} name 名称
 * @returns 
 */
 export const getPersonalMember = function (name,code) {
  return request.get(`/zhcpw/personalMembers/userGetCert?code=${code}&name=${name}`);
}
/**
 * 用户个人会员
 * @param {String} code 证书编号
 * @param {String} name 名称
 * @returns 
 */
 export const getCompanyMember = function (name,code) {
  return request.get(`/zhcpw/companyMembers/userGetCert?code=${code}&companyname=${name}`);
}
/**
 * 备案登记
 * @param {String} code 证书编号
 * @param {String} name 名称
 * @returns 
 */
 export const getBeiAn = function (name,code) {
  return request.get(`/zhcpw/beiAns/userGetCert?code=${code}&companyname=${name}`);
}
